import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ProjectCardComponent } from './project-card.component';

@NgModule({
  declarations: [
    ProjectCardComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    ProjectCardComponent
  ],
  providers: []
})
export class ProjectCardModule {}


